module.exports = __webpack_public_path__ + "static/fred-00accc6aa43eca80cb28b528f3dc9530.jpg";